import React from 'react';

function GalleryCard({img}) {
    console.log(img);
    
    return (
        <div className="galleryCard" data-aos="zoom-in" data-aos-delay="300">
            <img src={img} alt="Gallery" />
        </div>
    )
}

export default GalleryCard
